export default class MissingProductError extends Error {
};
